export default "__VITE_ASSET__DFLC4SXs__"